export default __webpack_public_path__ + "static/logo-nom-right-white-v4-3bf4d034ec1ad4deb5811bb9473298c8.png";